import { Selector } from "../common/Selector";
import { PlatformSource, RecentAnswer } from "winslow-core";

type SourceSelectorProps = {
  responses: RecentAnswer[];
  onChange: (value: PlatformSource) => void;
};

export const SourceSelector = ({
  responses,
  onChange,
}: SourceSelectorProps) => {
  // Map to store unique names and associated avatar URLs
  const sourceMap: Map<string, string | undefined> = new Map();

  const getPlatformSourceImage = (platformSource: PlatformSource) => {
    if (platformSource === PlatformSource.SLACK) {
      return "/icons/slack.svg";
    } else if (platformSource === PlatformSource.TEAMS) {
      return "/icons/teams.png";
    } else if (platformSource === PlatformSource.GMAIL) {
      return "/icons/gmail.svg";
    } else if (platformSource === PlatformSource.OUTLOOK) {
      return "/icons/outlook.svg";
    } else {
      return "/icons/winslow-ai-logo.svg";
    }
  };

  const getPlatformSourceLabel = (platformSource: string) => {
    if (platformSource === PlatformSource.SLACK) {
      return "Slack";
    } else if (platformSource === PlatformSource.TEAMS) {
      return "Teams";
    } else if (platformSource === PlatformSource.GMAIL) {
      return "Gmail";
    } else if (platformSource === PlatformSource.OUTLOOK) {
      return "Outlook";
    } else if (platformSource === PlatformSource.ANDROID_MOBILE) {
      return "Android";
    } else if (platformSource === PlatformSource.IOS_MOBILE) {
      return "iOS";
    } else {
      return "Winslow";
    }
  };

  responses.forEach((response: RecentAnswer) => {
    if (response.platformSource) {
      sourceMap.set(
        response.platformSource,
        getPlatformSourceImage(response.platformSource)
      );
    }
  });

  // Convert the map to an array of Option objects
  const options = Array.from(sourceMap.entries()).map(([source, image]) => ({
    value: source,
    label: getPlatformSourceLabel(source),
    imageUrl: image,
  }));

  // Add the "(no filter)" option at the beginning
  options.unshift({
    value: "",
    label: "(no filter)",
    imageUrl: undefined,
  });

  return (
    <Selector
      options={options}
      onChange={(value: string) => onChange(value as PlatformSource)}
    />
  );
};
